import { render, staticRenderFns } from "./ChatMessageActions.vue?vue&type=template&id=15e63928&scoped=true&"
import script from "./ChatMessageActions.vue?vue&type=script&lang=ts&"
export * from "./ChatMessageActions.vue?vue&type=script&lang=ts&"
import style0 from "./ChatMessageActions.vue?vue&type=style&index=0&id=15e63928&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e63928",
  null
  
)

export default component.exports